import axios from "../../axios-instance";
import cookies from 'js-cookie';
import {getPageData} from '../../modules/page-events';
import {createFormData} from '../../modules/helpers/form-data-helper';
import {showMessage} from '../../modules/helpers/login-flow-pages-helper';

const pageData = getPageData('page-login-data'),
    loginButton = document.getElementById('continue-login-button'),
    usernameInput = document.getElementById('username');

const initBasePageEvents = () => {
  // hack for ping/pong old logic
  window.handleLogin = true;

  document.getElementById('login-form').addEventListener('submit', e => {
		e.preventDefault();
		execContinue();
	});
  loginButton.removeAttribute('disabled');

  cleanLoginUsernameCookie();
};

const cleanLoginUsernameCookie = () => {
  const username = cookies.get('login-username');
  if (username) {
    usernameInput.value = username;
  }
  cookies.remove('login-username');
};

const execContinue = () => {
  if (pageData.captchaEnabled) {
    grecaptcha.execute();
  } else {
    checkRequest();
  }
};

window.recaptchaOnLoad = token => {
  checkRequest(token);
};

const resetRecaptchaIfEnabled = () => {
	if (pageData.captchaEnabled) {
		grecaptcha.reset();
	}
};

const checkRequest = (token= '') => {
	loginButton.setAttribute('disabled', 'disabled');

  const usernameData = {
    'username': usernameInput.value,
    'recaptcha_token': token
  };
  axios
    .post('/auth/initiate_login', createFormData(usernameData))
    .then(response => {
      const data = response.data;
      if (data.x360userId) {
        document.location.href = `/oauth2/login/${data.x360userId}`;
      } else {
        cookies.set('login-username', data.username, { secure: true });
        document.location.href = '/login_page/password';
      }
    })
    .catch(() => {
      showMessage('err-block', 'err-field', pageData.errMessages.serverErrorMessage);
      resetRecaptchaIfEnabled();
    })
    .then(() => {
      loginButton.removeAttribute('disabled');
    });
};

initBasePageEvents();
